<template>
  <v-dialog
    v-model="show"
    width="800"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <v-card>
      <v-card-title
        class="d-flex flex-row justify-space-between"
      >
        <v-container 
          fluid
          class="d-flex flex-row justify-space-between"
        >
          {{ name }}

          <v-spacer />

          <v-btn
            v-if="text!=origional"
            icon
            elevation="0"
            small
            @click="saveContent"
          >
            <v-icon
              small
              color="green"
            >
              mdi-content-save
            </v-icon>
          </v-btn>

          <v-btn
            icon
            elevation="0"
            small
            @click="preview=!preview"
          >
            <v-icon small>
              {{ preview ? 'mdi-text' : $vuetify.breakpoint.mobile ? 'mdi-view-split-horizontal' : 'mdi-view-split-vertical' }}
            </v-icon>
          </v-btn>

          <v-btn
            icon
            elevation="0"
            small
            @click="$emit('close')"
          >
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-container>
      </v-card-title>
      <v-card-text>
        <editor
          v-model="text"
          :mode="preview ? 'preview' : 'editor'"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Editor } from "@navanjr/vuetify-markdown-editor";

export default {
  components: { Editor},
  props: ['show', 'name'],
  data(){
    return {
      mode: "editor",
      text: "",
      origional: "",
      preview: false
    }
  },
  mounted(){
    this.fetch()
  },
  methods: {
    async fetch(){
      this.text = this.origional = await this.api.get(`/shop/content/${this.name}`)
    },
    async saveContent(){
      let save = await this.api.post(`/shop/content/${this.name}`, {text: this.text})
      if(save){
        this.origional = this.text
      }
      this.$emit('fetch')
      this.$emit('close')
    }
  }
}
</script>